import { useRouter } from 'next/router';
import { Viewer } from '~/context/viewer.context';
import Unauthorized from '~/exceptions/unauthorized.exception';
import useViewer from './viewer.hook';

interface useHasRoleProps {
  name: string | Array<string>;
  redirectTo?: string;
}

interface useHasRoleResult {
  hasRole: boolean;
}

export const hasRole = ({
  viewer,
  requestedRole,
}: {
  viewer: Viewer;
  requestedRole: string | Array<string>;
}): boolean => {
  return !!viewer?.roles.find(({ slug }) => {
    if (Array.isArray(requestedRole)) {
      return requestedRole.includes(slug);
    }

    return slug === requestedRole;
  });
};

const useHasRole = ({
  name: requestedRole,
  redirectTo,
}: useHasRoleProps): useHasRoleResult => {
  const { viewer } = useViewer();
  const router = useRouter();

  const doesViewerHaveRole = hasRole({ viewer, requestedRole });

  if (doesViewerHaveRole === false && redirectTo) {
    router.push(redirectTo);
    throw new Unauthorized();
  }

  return {
    hasRole: doesViewerHaveRole,
  };
};

export default useHasRole;
